<template>
  <section id="about">
    <v-container fluid>
      <v-row cols="10" align="center" justify="center">
        <v-col cols="10" md="6">
          <img src="@/assets/syxpay/syxpay_logo_about.png" style="max-width: 320px; margin-left: 1rem;"
            class="pl-md-6" />
          <p class="text-justify pt-4 pl-md-8">
            {{ translate('about_1') }}<br><br>
            {{ translate('about_2') }}
          </p>
          <div id="download">
            <h5 class="pl-md-8 pt-4" style="color: black; font-weight: 600; font-size: 15px;">
              {{ translate('download_now') }}
            </h5>
            <v-row class="pl-md-8">
              <v-col cols="4" md="3">
                <v-img src="@/assets/syxpay/download_google_store.png" />
              </v-col>
              <v-col cols="4" md="3">
                <v-img src="@/assets/syxpay/download_app_store.png" />
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="10" md="4">
          <v-img src="@/assets/syxpay/about.png" class="d-block mx-auto" max-width="400px" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: ['translate']
}
</script>

<style scoped>
.pl-md-6 {
  padding-left: 1rem !important;
}

.pl-md-8 {
  padding-left: 2rem !important;
  /* Adjust the padding as needed */
}
</style>
